import React from "react";
import { App, Article, Section, Headline } from "grommet";
import "grommet/grommet.min.css";
import Home from "./home";
import Resume from "./resume";
import Projects from "./projects";

const GrommetApp = props => (
  <App centered={false}>
    {props.page === "home" && <Home />}
    {props.page === "resume" && <Resume />}
    {props.page === "projects" && <Projects />}
  </App>
);

export default GrommetApp;



// WEBPACK FOOTER //
// ./src/components/grommet-app.js